import { jwtDecode } from 'jwt-decode';
import { JwtToken } from './models/jwt-token';

export class JwtDecoder {
  static decodeToken(token: string): JwtToken {
    return jwtDecode(token);
  }

  static getTokenExpirationDate(token: string): Date {
    const decoded: JwtToken = this.decodeToken(token);

    const date: Date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  static isTokenExpired(token: string, offset: number = 0): boolean {
    const date: Date | null = this.getTokenExpirationDate(token);

    if (!date) {
      return false;
    }

    // TokenType expired?
    const now: Date = new Date();
    now.setSeconds(now.getSeconds() + offset);

    return !(date > now);
  }
}
